// extracted by mini-css-extract-plugin
export default {"moreActionsButton":"_5d-oRGvYyyRq8z6KATGqoQ=="};